import { render, staticRenderFns } from "./long.vue?vue&type=template&id=43a9a99e"
import script from "./long.vue?vue&type=script&lang=js"
export * from "./long.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports